import React, { useEffect, useState } from 'react';
import { Carousel, Row, Col } from "react-bootstrap";

import { consultaImgInicio, UpdDatosInicio } from "../../../funciones/WebMasterFunction";

import Editor from "./Editor";

const EditBanner = () => {
    const [imagenes, setImagenes] = useState([]);
    const [control, setControl] = useState(true);

    const [preloader, setPreloader] = useState({
        icon: "fa fa-spinner fa-spin",
        text: "Cargando, Espera"
    });
    const [boton1, setBoton1] = useState({
        icon: "fa fa-save",
        text: "Guardar Cambios",
        disabled: false
    });
    
    /* useEffect(() =>{
        UpdDatosInicio (imagenes, "INICIO", (resp) => {
            console.log(resp)
        })
    }, [boton1]) */

    useEffect(() => {
        consultaImgInicio ("INICIO", (resp) => {
            let pre = "";

            (resp.length > 0) ? pre = { icon: "", text: "" } : pre = {
                icon: "",
                text: "No existen imagenes asociadas"
            }

            setPreloader (pre)
            setImagenes (resp)
        })
    }, []);

    const style = {
        position: "fixed",
        right: 10,
        color: "fff",
        paddingTop: 30
    }

    let carrusel = () => {
        if (imagenes.length === 0) return (
            <div className="text-danger" align="center"><i className={preloader.icon}></i> {preloader.text}</div>
        )

        return (
            <Carousel style={{zIndex: 0}} interval = {10000} controls = {false}>
                {imagenes.map(option => (
                    <Carousel.Item className="carousel" key ={option.id}>
                        <strong style={style} align="right">
                            <div className="fuente-monserrat principal-text" dangerouslySetInnerHTML={{ __html: option.title }}></div>
                            <div className="fuente-monserrat secondary-text" dangerouslySetInnerHTML={{ __html: option.text }}></div>
                        </strong>
                        <img className="img img-thumbnail" src={`${option.img}?${/* Math.floor(Math.random()*100000) */null}`} alt=""/>
                    </Carousel.Item>
                ))}
            </Carousel>
        )
    }

    let UdpImagenes = (tipo, valor, id) => {

        let idItem = "";
        let i = 0;
        imagenes.map(option => {
            if (id === option.id) idItem = i
            i++;
        })

        let imag = imagenes;
        imag[idItem][tipo] = valor
        
        setImagenes (imag)
        setControl (!control)
    }

    let updData = () => {
        if (boton1.disabled === true) return null;

        setBoton1 ({
            icon: "fa fa-spinner fa-spin",
            text: "Espera por Favor",
            disabled: true
        })
        
        UpdDatosInicio (imagenes, "INICIO", (resp) => {
            console.log(resp)
            setBoton1 ({
                icon: "fa fa-save",
                text: "Guardar Cambios",
                disabled: false
            })
        })
    }

    return (
        <React.Fragment>
            <div className="custom-alert-info">Editar Banner del Inicio</div>
            <div className="custom-mt-10">
                {carrusel()}
            </div>
            <div className="custom-mt-20" style={{padding:10, overflowY: "auto", maxHeight: "40vh", overflowX:"hidden", border: "1px solid #e1e1e1", borderRadius:"4px 4px", backgroundColor:"fff"}}>
                {imagenes.map(option => (
                    <Row key ={option.id}>
                        <Col md={12} className="custom-mt-10">
                            <div className="custom-alert-info">
                                {`Editar imagen N° ${option.id}`}
                            </div>
                        </Col>
                        <Col md={6} className="custom-mt-10">
                            <img style={{cursor: "pointer"}} src={`${option.img}?${/* Math.floor(Math.random()*100000) */null}`} className="img img-thumbnail" alt="" title="Haz click en la imagen para cambiarla"/>
                        </Col>
                        <Col md={6} className="custom-mt-10">
                            <div>
                                <Editor titulo = "Encabezado de la Imagen" funcion ={(valor) =>{UdpImagenes("title", valor, option.id)}}/>
                            </div>
                            <div className="custom-mt-20">
                                <Editor titulo = "Texto Secundario de la Imagen" funcion ={(valor) =>{UdpImagenes("text", valor, option.id)}}/>
                            </div>
                        </Col>
                    </Row>
                ))}
            </div>
            <div className="custom-mt-10" align="right">
                <button className="btn btn-primary" onClick={updData} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
            </div>
        </React.Fragment>
    )
}

export default EditBanner;


// WEBPACK FOOTER //
// ./src/views/WebMaster/Inicio/EditBanner.jsx